(function () {
    'use strict';

    run.admin.parts.sidebar = function () {
        const sidebarToggler = document.getElementById('sidebar_toggler');
        if (sidebarToggler !== null) {
            const sidebar = document.getElementById('admin_sidebar');
            sidebarToggler.addEventListener('click', function(e) {
                sidebar.classList.toggle('open');
                if (window.innerWidth < 468) {
                    setCookie('sidebar_visible', false, 180);
                }  else {
                    setCookie('sidebar_visible', sidebar.classList.contains('open'), 180);
                }
            })
        }

        // document.body.addEventListener('click', function(e) {
        //     console.log(e.target.classList); e.preventDefault();
        //     if (e.target.classList.contains('closes_sidebar')) {
        //     }
        // })
    };
})();
